// import PropTypes from 'prop-types';
import React from 'react';
import { i18nClient } from '@sailor/i18n-web';
import { owlAddJsError } from '@m2h/common/raptor';
import ListEmptyView from '@/components/ListEmptyView';

// class ErrorBoundary extends React.Component {
//   // state = {
//   //   hasError: false,
//   //   error: null,
//   // }
//   //
//   // componentDidCatch(error, errorInfo) {
//   //   const e = { error, ...errorInfo };
//   //   console.log('ErrorBoundary Catch:', e.componentStack);
//   //   // 主动上报
//   //   owlAddJsError('ErrorBoundary Catch:', e);
//   //   // 自定义处理
//   //   // @ts-ignore
//   //   this.props.onError && this.props.onError(e);
//   // }
//   //
//   // // 从错误中映射状态对象
//   // static getDerivedStateFromError(error) {
//   //   return {
//   //     hasError: true,
//   //     error,
//   //   };
//   // }
//   //
//   // render() {
//   //   if (this.state.hasError) {
//   //     // @ts-ignore
//   //     return this.props.fallback;
//   //   }
//   //   return this.props.children;
//   // }
//   constructor(props: any) {
//     super(props);
//     this.state = { hasError: false };
//   }
//
//   // 更新state使下一次渲染显示降级UI
//   static getDerivedStateFromError() {
//     return { hasError: true };
//   }
//
//   // 出现错误
//   componentDidCatch(error: any, errorInfo: any) {
//     const componentStack = errorInfo?.componentStack || 'No component stack available';
//     console.log('ErrorBoundary caught:', error, componentStack);
//     try {
//       // reportRaptorMetrics?.({ marketing_growth_components_error: 1 }, { error: String(error), errorInfo: componentStack });
//     } catch (reportError) {
//       console.log('ErrorBoundary reportRaptorMetrics error:', reportError);
//     }
//   }
//
//   render() {
//     if ((this.state as any).hasError) {
//       // return null; // 降级不展示
//       return <div>12313123</div>;
//     }
//     return this.props.children;
//   }
// }
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // 更新 state 以显示降级 UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // 可以在这里记录错误信息，例如发送到后端
    console.error('Uncaught error:', error, errorInfo);
  }

  refershUI() {
    window.location.reload();
  }

  render() {
    // @ts-ignore
    if (this.state.hasError) {
      // 渲染降级 UI
      // return <h2>Something went wrong.</h2>;
      return (
        <ListEmptyView
          title=""
          icon="assets://common/empty_list.png"
          dtCode=""
          retryBtnTitle={i18nClient.getText('basic_address_refreshbutton')}
          onClickRetryBtn={() => { this.refershUI(); }}
        />
      );
    }

    return this.props.children;
  }
}

// ErrorBoundary.propTypes = {
//   fallback: PropTypes.node,
//   onError: PropTypes.func,
//   children: PropTypes.element,
// };
export default ErrorBoundary;
